const awsweb = {
	Auth: {
		region: "ap-southeast-2",
		userPoolId: "ap-southeast-2_Hq8t7VOWl",
		userPoolWebClientId: "2c4dnkjhfcb5g1stcgt933857v",
	}
};


export default awsweb;